(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('FirstNameSearch', FirstNameSearch);

    FirstNameSearch.$inject = ['$resource'];

    function FirstNameSearch($resource) {
        var resourceUrl =  'api/_search/first-names/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
